export const deviceErrors = ['BadDeviceToken', 'Unregistered'];
export const credentialErrors = ['BadCertificate', 'BadCertificateEnvironment', 'DeviceTokenNotForTopic'];

export const apnsErrors: Record<string, string> = {
  BadCollapseId: 'The collapse identifier exceeds the maximum allowed size.',
  BadDeviceToken:
    'The specified device token is invalid. Verify that the request contains a valid token and that the token matches the environment.',
  BadExpirationDate: 'The apns-expiration value is invalid.',
  BadMessageId: 'The apns-id value is invalid.',
  BadPriority: 'The apns-priority value is invalid.',
  BadTopic: 'The apns-topic value is invalid.',
  DeviceTokenNotForTopic: "The device token doesn't match the specified topic.",
  DuplicateHeaders: 'One or more headers are repeated.',
  IdleTimeout: 'Idle timeout.',
  InvalidPushType: 'The apns-push-type value is invalid.',
  MissingDeviceToken:
    "The device token isn't specified in the request :path. Verify that the :path header contains the device token.",
  MissingTopic:
    "The apns-topic header of the request isn't specified and is required. The apns-topic header is mandatory when the client is connected using a certificate that supports multiple topics.",
  PayloadEmpty: 'The message payload is empty.',
  TopicDisallowed: 'Pushing to this topic is not allowed.',
  BadCertificate: 'The certificate is invalid.',
  BadCertificateEnvironment: 'The client certificate is for the wrong environment.',
  ExpiredProviderToken: 'The provider token is stale and a new token should be generated.',
  Forbidden: 'The specified action is not allowed.',
  InvalidProviderToken: "The provider token is not valid, or the token signature can't be verified.",
  MissingProviderToken:
    'No provider certificate was used to connect to APNs, and the authorization header is missing or no provider token is specified.',
  BadPath: 'The request contained an invalid :path value.',
  MethodNotAllowed: "The specified :method value isn't POST.",
  Unregistered:
    'The device token is inactive for the specified topic. There is no need to send further pushes to the same device token, unless your application retrieves the same device token.',
  PayloadTooLarge: 'The message payload is too large. For information about the allowed payload size.',
  TooManyProviderTokenUpdates:
    "The provider's authentication token is being updated too often. Update the authentication token no more than once every 20 minutes.",
  TooManyRequests: 'Too many requests were made consecutively to the same device token.',
  InternalServerError: 'An internal server error occurred.',
  ServiceUnavailable: 'The service is unavailable.',
  Shutdown: 'The APNs server is shutting down.'
};
